import styled from 'styled-components';
import { colors } from 'pages/new-questions/styles/common';

export const DisagreeButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  margin-top: 16px;
  width: fit-content;
  background: ${colors.white};
  border: 1.5px solid ${colors.red};
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.2s;

  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.red};

  &:hover {
    background: ${colors.redBackground};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
